import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormBuilder } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from 'src/app/common/common.service';
import { GeneralConfiService } from './general-confi.service';
import Swal from 'sweetalert2';
import { query } from '@angular/animations';

@Component({
  selector: 'app-general-configuration',
  templateUrl: './general-configuration.component.html',
  styleUrls: ['./general-configuration.component.css']
})
export class GeneralConfigurationComponent implements OnInit {

  isEditStep: string = 'false';
  isEditAwarness: string = 'false';
  country: string = '';
  awarenessList: [];
  stepList: [];
  id: string = '';
  type: number = 1;
  text: string = '';
  textTerm: string = '';
  textrefund: string = '';
  textSupport: string = '';
  ckeConfig: any;

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private GeneralConfiService: GeneralConfiService
  ) { }

  ngOnInit() {
    this.spinner.show();
    this.getconfiguration('Awarness');
    this.getconfiguration('Steps');
    this.startLoadingSpinner();
    this.getprivacyPolicy();
    this.getTermNCondtion()
    this.supportCenter();
    this.getrefundpolicy();

  }

  startLoadingSpinner() {

    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 2000);
  }

  getconfiguration(type) {
    if (type == 'Awarness') {
      this.GeneralConfiService.getawarnessList().subscribe(res => {

        if ((res["message"] = "Success")) {
          this.awarenessList = res.data && res.data.awarenessList ? res.data.awarenessList : [];
          let length = this.awarenessList.length;
          if (length > 0) {
            this.isEditAwarness = 'true';
          }

        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: res.msg
          });
        }
      });
    } else {
      this.GeneralConfiService.getStepList().subscribe(res => {
        if ((res["message"] = "Success")) {
          this.stepList = res.data && res.data.stepList ? res.data.stepList : [];
          let length = this.stepList.length;
          if (length > 0) {
            this.isEditStep = 'true';
          }
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: res.msg
          });
        }
      });

    }


  }

  getprivacyPolicy() {
    let query = "status=privacyPolicy";
    this.GeneralConfiService.getSetting(query).subscribe(res => {
      if ((res["message"] = "Success")) {
        this.text = res.data || '';


      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });




  }
  supportCenter() {
    let query = "status=support";
    this.GeneralConfiService.getSetting(query).subscribe(res => {
      if ((res["message"] = "Success")) {
        this.textSupport = res.data || '';

      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });




  }
  getTermNCondtion() {
    let query = "status=termsNConditions";
    this.GeneralConfiService.getSetting(query).subscribe(res => {
      if ((res["message"] = "Success")) {
        this.textTerm = res.data || '';

      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });




  }
  getrefundpolicy() {
    let query = "status=refundPolicy";
    this.GeneralConfiService.getSetting(query).subscribe(res => {
      if ((res["message"] = "Success")) {
        this.textrefund = res.data || '';

      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });




  }

  SubmitPrivacy() {
    let value = {
      text: this.text,
      status: "privacyPolicy"
    }

    this.GeneralConfiService.saveSetting(value).subscribe(res => {

      if ((res["message"] = "Success")) {
        Swal.fire("Success", "Saved successfully!", "success");

      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });
  }
  SubmitSupportCenter() {
    let req = {
      text: this.textSupport,
      status: "support"
    }

    this.GeneralConfiService.saveSetting(req).subscribe(res => {

      if ((res["message"] = "Success")) {
        Swal.fire("Success", "Saved successfully!", "success");

      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });
  }
  SubmitContact() {
    let value = {
      text: this.textTerm,
      status: "termsNConditions"
    }
    this.GeneralConfiService.saveSetting(value).subscribe(res => {

      if ((res["message"] = "Success")) {
        Swal.fire("Success", "Saved successfully!", "success");
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });
  }
  countryList = ["USA","INDIA"]
  Submitrefundpolicy() {
    let req = {
      text: this.textSupport,
      status: "refundPolicy",
    }

    this.GeneralConfiService.saveSetting(req).subscribe(res => {

      if ((res["message"] = "Success")) {
        Swal.fire("Success", "Saved successfully!", "success");

      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });
  }
}
